import { ApplicationConfig } from '@angular/core';
import { provideRouter, withComponentInputBinding } from '@angular/router';
import { UnityUiAuthManagementProviders } from '@unity/auth-management-ui-lib';
import { BaseUnityAppConfig } from '@unity/core-components-lib';
import { provideMsal } from '@unity/core-login-lib';
import { APP_CONFIG_PATH, NAVIGATION_DATA_PATH } from '@unity/core-models-lib';
import { LOGGERS, LoggingService, MultiLoggingService, UnityCoreLoggingService } from '@unity/core-services-lib';
import { MarketMessengerAppConfigDefaultProviders } from '@unity/market-messenger-core-lib';
import { MessageVaultAppConfigDefaultProviders } from '@unity/message-vault-core-lib';
import { UnityMessengerAppConfigDefaultProviders } from '@unity/unity-messenger-core-lib';
import { UnityCoreUiRoutes } from './app.routes';

export const appConfig: ApplicationConfig = { //TODO document these things
  providers: [
    {
      provide: NAVIGATION_DATA_PATH,
      useValue: '/assets/config/navigation.json', //TODO document doing this on app creation
    },
    {
      provide: APP_CONFIG_PATH,
      useValue: '/assets/config/app-config-settings.json', //TODO document doing this on app creation
    },
    {
      provide: LoggingService,
      useClass: MultiLoggingService
    },
    {
      provide: LOGGERS,
      useClass: UnityCoreLoggingService,
      multi: true
    },
    ...BaseUnityAppConfig,
    ...MarketMessengerAppConfigDefaultProviders,
    ...UnityMessengerAppConfigDefaultProviders,
    ...UnityUiAuthManagementProviders,
    ...MessageVaultAppConfigDefaultProviders,
    provideMsal(),
    provideRouter(UnityCoreUiRoutes, withComponentInputBinding()),
  ],
};
